module.exports = __webpack_public_path__ + "img/delete.e9c9f064.svg";